import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NavLink, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { deleteInArray, DropdownAction, errorCatch, GET, getObjectDisplay, JSXMap, JSXIndex, Model, POST, QueryDetail, QueryOrder, QueryParam, updateArrayInArray, updateInArray, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext, If } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';
import FilterFieldLabel from '../../components/FilterFieldLabel';
import MDEditor from '@uiw/react-md-editor';
import rehypeSanitize from "rehype-sanitize";
import User from '../../../common/User';
import { Badge, Button, Empty, Modal, Tabs, message } from 'antd';
import { ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import ContextRoute, { ContextList } from '../ContextRoute';
import { ContextOrganizerElement } from '../../components/ContextElement';
import { BreadcrumbsProvider, TestingContext, useLayoutWidthContext, useNearestObjectContext } from '../../../common/Context';
import { useSelector } from 'react-redux';
import { access, defaultRoute, goTo } from '../../../common/Tool';
import badgeCheckIcon from '../../../icons/badge.png' // relative path to image 
import Markdown from 'markdown-to-jsx';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Checkbox, DotLoading } from 'antd-mobile';
import Judge from '../../../fedance-ui/Judge';
import { UserName } from '../../../common/User';
import { render } from 'react-dom';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export function AttestationList(props) {
    const { display } = props;
    const auth = useAuth()
    const meta = useMetaContext()


    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj) => {
        let p = []
        if (obj && _.isArray(obj)) {
            p = [...obj]
        } else if (obj && _.isObject(obj)) {
            p = [...obj?.properties]
        }

        p = p.filter(n => n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt")
        p = p.map(n => (n.type == "object") ? {
            ...n,
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]

                return [{
                    title: "Создать",
                    form: Model,

                    links: true,
                    defaultModelActions: true,
                    defaultModelActionMeta: (mobject) => cleanProperties(mobject),
                    defaultCollectionActions: true,
                    defaultCollectionActionMeta: (mobject) => cleanProperties(mobject),

                    meta: cleanProperties(m),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
                ]
            }
        } : n)
        p = p.map(n => (n.type == "string" && !n?.db?.size) ? {
            ...n,
            // type: "text"

            type: "func",
            render: (auth, item, value, onChange) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    previewOptions={{
                        rehypePlugins: [[rehypeSanitize]],
                    }}
                    preview={"edit"}
                    // hideToolbar={true}
                    overflow={false}
                // extraCommands={[codePreview, commands.fullscreen]}
                />)
            }
        } : n)
        return (obj && _.isArray(obj)) ? p : { ...obj, properties: p }
    }

    // CollectionServer
    // source: ({
    // 	lock,
    // 	unlock,
    // 	page,
    // 	count,
    // 	sorting,
    // 	filter,
    // 	apply
    // })=>{}

    return (<PageLayout hideSider={true} /*hideBreadcrumbs={true}*/>
        <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
            <CollectionServer
                auth={auth}
                name={"TestiSudeiskikhAttestatsii"}
                queryDetail={"collection"}
                filters={() => filtersFromMeta("TestiSudeiskikhAttestatsii")}

                mode="list"
                // render={(item) => (display) ? display(item) : (
                //     <div style={{ padding: "0px 5px" }}>
                //         <div>
                //             <a href={`${item.ID}`}>{getObjectDisplay(item, "TestiSudeiskikhAttestatsii", meta)}</a>
                //         </div>
                //         <div style={{ color: "#6a6a6a" }}></div>
                //     </div>
                // )}
                customRender={(items, {
                    collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    collectionActions,
                    modelActions,
                    update,

                    mobject,
                    name,
                    field,
                    fieldName,
                    defaultCollectionAction,
                    defaultModelAction
                }) => (<div>
                    {(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
                    {JSXMap(items, (item, idx) => {
                        return (<div key={item.ID || idx} style={{ width: "100%", display: "flex", gap: "5px" }}>
                            <div style={{ flex: "1 1 auto" }}>
                                {(display) ? display(item) : (
                                    <div style={{ padding: "0px 5px" }}>
                                        {/* <div>
                                            <a href={`${item.ID}`}>{getObjectDisplay(item, "TestiSudeiskikhAttestatsii", meta)}</a>
                                        </div>
                                        <div style={{ color: "#6a6a6a" }}></div> */}
                                    </div>
                                )}
                            </div>
                            <div style={{ flex: "0 0" }}>
                                <DropdownAction
                                    style={{ padding: "0" }}
                                    button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <i className="fa fa-ellipsis-h"></i>
                                    </div>)}
                                    items={modelActions(item, idx, { name, mobject })?.map((e, idx) => ({
                                        key: e.key || idx,
                                        auth: auth,
                                        mode: "MenuItem",
                                        object: item,
                                        collection: collection,
                                        setCollection: setCollection,
                                        ...e
                                    }))} />
                            </div>
                        </div>)
                    })}
                </div>)}

                // defaultCollectionActions={true}
                // defaultCollectionActionMeta={(mobject) => cleanProperties(mobject)}
                collectionActions={() => [{
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/query-create/testisudeiskikhattestatsii`, { ...values }, ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    }, (err) => errorCatch(err, unlock)),
                    title: "Создать",
                    form: Model,
                    meta: [
                        // {
                        //     label: "Выполнен",
                        //     name: "Done",
                        //     type: "bool",
                        // },
                        {
                            name: "Sudya",
                            type: "object",
                            mode: "dialog",
                            label: "Судья",
                            relation: {
                                type: "many-one",
                                reference: {
                                    object: "SudiFederatsii",
                                    property: "ID"
                                },
                                uiFilter: () => [
                                    {
                                        name: "user.lastname",
                                        sort: true,
                                        filter: true,
                                        sorted: "ASC"
                                    },
                                    {
                                        name: "user.firstname",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "user.patronymic",
                                        sort: true,
                                        filter: true,
                                    },

                                    {
                                        name: "user.email",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        label: "Телефон",
                                        name: "user.phone",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "user.gender",
                                        sort: true,
                                        filter: true,
                                        display: (o) => o.name,
                                    },
                                    {
                                        label: "Дата создания",
                                        name: "createdAt",
                                        type: "date",
                                        sort: true,
                                        filter: true,
                                    },
                                ],
                                displayString: (item) => {
                                    return item?.user?.lastname + " " + item?.user?.firstname + " (" + item?.regionalnoeOtdelenie?.nazvanie + ")"
                                },
                                display: (item) => {
                                    return (<div>
                                        <User item={item?.user} />
                                        <div style={{
                                            fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>{item?.regionalnoeOtdelenie?.nazvanie}</div>
                                    </div>
                                    )
                                },
                            },
                            queryFilter: [
                                QueryDetail("collection"),
                                QueryParam("w-nnu-DokumentRegistratsii", 0),
                                QueryParam("w-nu-DokumentVikhoda", 0),
                                QueryOrder("user.firstname", "ASC")
                            ]
                        },
                        {
                            name: "KategoriyaSudeistva",
                            type: "object",
                            label: "Категория судейства",
                            relation: {
                                type: "many-one",
                                reference: {
                                    object: "KategoriiSudei",
                                    property: "ID"
                                },
                            },
                            queryFilter: [
                                QueryDetail("model"),
                                QueryOrder("nazvanieKategorii", "ASC"),
                            ]
                        },
                        {
                            name: "Shablon",
                            type: "object",
                            label: "Шаблон",
                            relation: {
                                type: "many-one",
                                reference: {
                                    object: "ShabloniTestov",
                                    property: "ID"
                                },
                            },
                        }
                    ],
                }]}
                // linksModelActions={true}
                // defaultModelActions={true}
                // defaultModelActionMeta={(mobject, item) => cleanProperties(mobject)}
                modelActions={(item, index, { name, mobject }) => [
                    // {
                    //     key: "change",
                    //     title: "Изменить",
                    //     action: (values, unlock, close, { collection, setCollection }) => POST(auth, `/api/query-update/testisudeiskikhattestatsii`, { ...values, ID: item.ID }, ({ data }) => {
                    //         setCollection(updateInArray(collection, data));
                    //         close();
                    //     }, (err) => errorCatch(err, unlock)),
                    //     form: Model,
                    //     modal: {
                    //         width: "700px"
                    //     },
                    //     options: {
                    //         initialValues: {
                    //             ...item
                    //         },
                    //     },
                    //     meta: [
                    //         {
                    //             label: "Выполнен",
                    //             name: "Done",
                    //             type: "bool",
                    //         },
                    //         {
                    //             name: "Sudya",
                    //             type: "object",
                    //             mode: "dialog",
                    //             label: "Судья",
                    //             relation: {
                    //                 type: "many-one",
                    //                 reference: {
                    //                     object: "SudiFederatsii",
                    //                     property: "ID"
                    //                 },
                    //                 uiFilter: () => [
                    //                     {
                    //                         name: "user.lastname",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },
                    //                     {
                    //                         name: "user.firstname",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },
                    //                     {
                    //                         name: "user.patronymic",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },

                    //                     {
                    //                         name: "user.email",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },
                    //                     {
                    //                         label: "Телефон",
                    //                         name: "user.phone",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },
                    //                     {
                    //                         name: "user.gender",
                    //                         sort: true,
                    //                         filter: true,
                    //                         display: (o) => o.name,
                    //                     },
                    //                     {
                    //                         label: "Дата создания",
                    //                         name: "createdAt",
                    //                         type: "date",
                    //                         sort: true,
                    //                         filter: true,
                    //                     },
                    //                 ],
                    //                 displayString: (item) => {
                    //                     return item?.user?.lastname + " " + item?.user?.firstname + " (" + item?.regionalnoeOtdelenie?.nazvanie + ")"
                    //                 },
                    //                 display: (item) => {
                    //                     return (<div>
                    //                         <User item={item?.user} />
                    //                         <div style={{
                    //                             fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                    //                             whiteSpace: "nowrap",
                    //                             overflow: "hidden",
                    //                             textOverflow: "ellipsis"
                    //                         }}>{item?.regionalnoeOtdelenie?.nazvanie}</div>
                    //                     </div>
                    //                     )
                    //                 },
                    //             },
                    //             queryFilter: [
                    //                 QueryDetail("collection"),
                    //                 QueryOrder("user.firstname", "ASC")
                    //             ]
                    //         },
                    //         {
                    //             name: "KategoriyaSudeistva",
                    //             type: "object",
                    //             label: "Категория судейства",
                    //             relation: {
                    //                 type: "many-one",
                    //                 reference: {
                    //                     object: "KategoriiSudei",
                    //                     property: "ID"
                    //                 },
                    //             },
                    //             queryFilter: [
                    //                 QueryDetail("model"),
                    //                 QueryOrder("nazvanieKategorii", "ASC"),
                    //             ]
                    //         },
                    //         {
                    //             name: "Shablon",
                    //             type: "object",
                    //             label: "Шаблон",
                    //             relation: {
                    //                 type: "many-one",
                    //                 reference: {
                    //                     object: "ShabloniTestov",
                    //                     property: "ID"
                    //                 },
                    //             },
                    //         }
                    //     ],
                    //     object: item,
                    // },

                    {
                        auth: auth,
                        title: "Просмотр",
                        action: (values, unlock, close) => {
                            goTo(`/app/reports/testisudeiskikhattestatsii/${item?.ID}`)
                        }
                    },
                    If((item?.passed), {
                        key: "notpassed",
                        title: <span>Установить "Не сдал"</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите установить статус НЕ СДАЛ?`,
                                icon: <ExclamationCircleOutlined />,
                                content: (<div>
                                    {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                                        <div>{mobject?.label}</div>
                                    </div>}
                                    <div>{getObjectDisplay(item, name, meta)}</div>
                                </div>),
                                okText: "Да",
                                okType: 'warning',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/testisudeiskikhattestatsii/notpassed/${item.ID}`,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, { ...item, certificateNumber: data?.certificateNumber, passed: data?.passed }))
                                        }, errorCatch
                                    );
                                },
                            });
                        },
                    }),
                    // If((!item?.passed), {
                    //     key: "passed",
                    //     title: <span>Установить "Сдал"</span>,
                    //     action: (values, unlock, close, { collection, setCollection }) => {
                    //         Modal.confirm({
                    //             title: `Вы уверены что хотите установить статус СДАЛ?`,
                    //             icon: <ExclamationCircleOutlined />,
                    //             content: (<div>
                    //                 {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                    //                     <div>{mobject?.label}</div>
                    //                 </div>}
                    //                 <div>{getObjectDisplay(item, name, meta)}</div>
                    //             </div>),
                    //             okText: "Да",
                    //             okType: 'warning',
                    //             cancelText: "Нет",
                    //             onOk: () => {
                    //                 GET(auth, `/api/testisudeiskikhattestatsii/passed/${item.ID}?certificateNumber=scsdsv`,
                    //                     ({ data }) => {
                    //                         setCollection(updateInArray(collection, { ...item, certificateNumber: data?.certificateNumber, passed: data?.passed }))
                    //                     }, errorCatch
                    //                 );
                    //             },
                    //         });
                    //     },
                    // }),
                    If((!item?.passed), {
                        key: "passed",
                        title: <span>Установить "Сдал"</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите установить статус СДАЛ и присвоить номер свидетельства ${values?.certificateNumber}?`,
                                icon: <ExclamationCircleOutlined />,
                                content: (<div>
                                    {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                                        <div>{mobject?.label}</div>
                                    </div>}
                                    <div>{getObjectDisplay(item, name, meta)}</div>
                                </div>),
                                okText: "Да",
                                okType: 'warning',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/testisudeiskikhattestatsii/passed/${item.ID}?certificateNumber=${values?.certificateNumber}`,
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, { ...item, certificateNumber: data?.certificateNumber, passed: data?.passed }))
                                        }, errorCatch
                                    );
                                },
                                onCancel: unlock
                            });
                        },
                        form: Model,
                        options: {
                            initialValues: {
                                ...item
                            },
                        },
                        meta: [
                            {
                                type: "func",
                                render: () => {
                                    return (<div>
                                        <div style={{paddingBottom:"15px"}}>
                                            {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                                                <div>{mobject?.label}</div>
                                            </div>}
                                            <div>{getObjectDisplay(item, name, meta)}</div>
                                        </div>
                                    </div>)
                                }
                            },
                            {
                                label: "Номер свидетельства",
                                name: "certificateNumber",
                                type: "string",
                            }
                        ],
                        object: item,
                    }),
                    {
                        key: "delete",
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            Modal.confirm({
                                title: `Вы уверены что хотите удалить элемент?`,
                                icon: <ExclamationCircleOutlined />,
                                content: (<div>
                                    {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                                        <div>{mobject?.label}</div>
                                    </div>}
                                    <div>{getObjectDisplay(item, name, meta)}</div>
                                </div>),
                                okText: "Да",
                                okType: 'danger',
                                cancelText: "Нет",
                                onOk: () => {
                                    GET(auth, `/api/query-delete/testisudeiskikhattestatsii/${item.ID}`,
                                        () => {
                                            setCollection(deleteInArray(collection, item))
                                        }, errorCatch
                                    );
                                },
                            });
                        },
                    }
                ]}

            />
        </div>
    </PageLayout>)
}
export function Attestation(props) {
    let { id } = useParams();
    const auth = useAuth();
    let navigate = useNavigate();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const [loading, setLoading] = useState(false)
    const [test, setTest] = useState()
    const [result, setResult] = useState()

    useEffect(() => {
        GET(auth, `/api/testisudeiskikhattestatsii/result-for-admin/${id}`,
            ({ data }) => {
                // console.log(data);
                setTest(data?.test)
                setResult(data);
                setActiveKey("end");
            }, errorCatch)
    }, [])

    const [testing, setContextObject] = useNearestObjectContext()

    const { pathname, hash, key } = useLocation();
    useEffect(() => {
        if (hash) {
            const key = hash.replace('#', '');
            setTimeout(() => {
                const element = document.querySelectorAll(`[data-node-key="${key}"]`);
                if (element && element.length) {
                    element[0].scrollIntoView({ behavior: 'smooth', block: "end" });
                }
            }, 500);
        }
    }, []);
    const [activeKey, _setActiveKey] = useState(hash.slice(1) || 'begin')
    const setActiveKey = (value) => _setActiveKey(o => {
        if (_.isFunction(value)) {
            navigate("#" + value(o))
            return value(o)
        } else {
            navigate("#" + value)
            return value
        }
    });

    function declOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }

    // use:
    // declOfNum(1, ['балл', 'балла', 'баллов']);

    const [mini, setMini] = useState(false);

    const setDone = useCallback(() => {
        if (test && !test?.done) {
            Modal.confirm({
                title: 'Готово?',
                icon: <ExclamationCircleFilled />,
                content: 'Вы уверены что ответили на все вопросы, хотите завершить тест и отправив результаты на проверку?',
                cancelText: "Отмена",
                okText: "Да",
                onOk: async () => {
                    GET(auth, `/api/testisudeiskikhattestatsii/done/${test?.ID}`, ({ data }) => {
                        setTest({ ...test, done: true })
                        message.open({
                            type: 'success',
                            content: 'Тест отправлен',
                        });
                    }, errorCatch)
                },
            })
        }
    }, [test])
    const isDone = useMemo(() => {
        if (!test?.testVoprosiSudeiskikhAttestatsiiTest) {
            return false
        }

        let x = test?.testVoprosiSudeiskikhAttestatsiiTest?.find((e, idx) => {
            return !e?.testVariantiOtvetovVopros?.find(a => a?.selected)
        })
        let check = true;
        if (test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya?.length) {
            check = _.every(test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya, { 'completed': true });
        }

        return !x && check
    }, [test])
    const tabsNum = useMemo(() => {
        if (!test?.testVoprosiSudeiskikhAttestatsiiTest) {
            return []
        }
        let arr = test?.testVoprosiSudeiskikhAttestatsiiTest?.map((e, idx) => (`q${e?.ID}`))
        let testingPage = [];
        if (test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya?.length) {
            testingPage.push("test")
        }
        return ['begin', ...arr, ...testingPage, 'end']
    }, [test])
    const prev = useCallback(() => {
        let idx = tabsNum.findIndex(e => e === activeKey)
        if (idx > 0) {
            setActiveKey(tabsNum[idx - 1])
        }
    }, [activeKey, tabsNum])
    const next = useCallback(() => {
        let idx = tabsNum.findIndex(e => e === activeKey)
        if ((idx + 1) < tabsNum.length) {
            setActiveKey(tabsNum[idx + 1])
        }
    }, [activeKey, tabsNum])

    const realValue = (valueType, value) => {
        if (valueType == 1) {
            if (value < 0) {
                return (<i className='fa fa-minus'></i>)
            } else if (value > 0) {
                return (<i className='fa fa-plus'></i>)
            } else {
                return "\"нет оценки\""
            }
        }

        return value
    }

    const tabs = useMemo(() => {
        if (!test?.testVoprosiSudeiskikhAttestatsiiTest) {
            return []
        }
        let begin = {
            key: 'begin',
            title: (mini) ? (
                <div className='' style={{ minWidth: "12px", padding: "0px", lineHeight: "16px" }}>
                    <i className="fa fa-exclamation"></i>
                </div>
            ) : (
                <div style={{ lineHeight: "16px", textAlign: "left" }}>
                    <div>Начало</div>
                    <div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: "space-between", gap: "3px" }}>
                        <div style={{ fontSize: "10px", flex: "1 1 auto" }}>{dayjs(test?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>
                    </div>
                </div>
            ),
            children: (<div className='question-begin' style={{ padding: "5px 10px", display: "flex", flexDirection: "column" }}>
                <div style={{ fontSize: "14px" }}>
                    <Markdown className="md">
                        {(test && test?.shablon?.annotatsiya) ? test?.shablon?.annotatsiya : ""}
                    </Markdown>
                </div>
            </div>)
        }
        let end = {
            key: 'end',
            title: (mini) ? (
                <div className='' style={{ minWidth: "12px", padding: "0px", lineHeight: "16px" }}>
                    {!isDone && <i className="fa fa-circle-o"></i>}
                    {isDone && <i className="fa fa-check" style={{ color: (test?.done) ? 'green' : "grey" }}></i>}
                </div>
            ) : (
                <div className='question-end' style={{ lineHeight: "16px", textAlign: "left" }}>
                    <div>Готово</div>
                    <div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: "space-between", gap: "3px" }}>
                        <div style={{ fontSize: "10px", flex: "1 1 auto" }}>
                            {!isDone && <DotLoading />}
                            {isDone && <i className="fa fa-check" style={{ color: (test?.done) ? 'green' : "grey" }}></i>}
                        </div>
                    </div>
                </div>
            ),
            children: (<div style={{ padding: "5px 10px", display: "flex", flexDirection: "column" }}>
                <div style={{ fontSize: "14px", textAlign: "center" }}>
                    {(!isDone && !test?.done) && <div>
                        <div style={{ paddingBottom: "15px" }}>Пожалуйста, заполните ответы на все вопросы теста!</div>
                        <div style={{ fontSize: "13px", fontWeight: "300", paddingBottom: "15px" }}>После заполнения всех вопросов можно будет вернуться сюда и завершить тест, отправив результаты на проверку</div>
                    </div>}
                    {(isDone && !test?.done) && <div>
                        <div style={{ paddingBottom: "15px" }}>Вы заполнили ответы на все вопросы теста. Если вы уверены в том, что ответили на все вопросы правильно и готовы завершить тестирование, то нажмите на кнопку ниже.</div>
                        <div style={{ fontSize: "13px", fontWeight: "300", paddingBottom: "15px" }}>ВНИМАНИЕ! После того как вы подтвердите выполнение теста нажатием на кнопку "Готово" ваши ответы будут отправлены на проверку и их нельзя будет изменить. Тест будет считаться завершенным.</div>
                        <Button style={{ minWidth: "200px" }} color={(isDone) ? 'success' : "warning"} onClick={setDone}>Готово</Button>
                    </div>}
                    {(test?.done) && <div>
                        {/* <div style={{ paddingBottom: "15px", fontSize: "16px" }}>Тест {(result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent && result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov) ? "пройден!" : "не пройден"}</div> */}

                        <div style={{ textAlign: "center" }}>
                            {/* {(result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent && result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov) && <div style={{ textAlign: "center" }}>
                                <img src={badgeCheckIcon} style={{ width: "125px" }} />
                            </div>} */}
                            <div style={{ fontSize: "18px" }}>
                                <div>Ваш результат теоретического теста</div>
                                <div style={{ color: (result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) ? "green" : "red", fontSize: "26px" }}>{result?.nabranniiProtsent}%</div>
                            </div>
                            <div style={{ fontSize: "12px", fontWeight: "300", paddingBottom: "15px" }}>Для прохождения необходимо {result?.test?.prokhodnoiProtsent}%</div>
                        </div>

                        <div style={{ textAlign: "center" }}>

                            <div><i className="fa fa-circle" style={{ color: "#cbcbcb" }}></i> Набрано баллов: <span style={{ fontWeight: "bold" }}>{result?.summaBallov} из {result?.vsegoBallovVTeste}</span></div>

                            <div><i className="fa fa-check-circle-o" style={{ color: "green" }}></i> Правильных ответов: {result?.pravilnoOtvechennieVoprosi}</div>

                            <div><i className="fa fa-times-circle-o" style={{ color: "red" }}></i> Неправильных ответов: {result?.nePravilnoOtvechennieVoprosi}</div>
                        </div>

                        <div style={{ paddingTop: "5px" }}>
                            {/* {(!result?.protocoli?.find(x => x.hasError)) && <div style={{ fontSize: "16px", color: '#87d068' }}>
                                Все протоколы заполнены корректно
                            </div>}
                            {(result?.protocoli?.find(x => x.hasError)) && <div style={{ fontSize: "16px", color: "red", paddingBottom:"10px" }}>
                                Ошибки в протоколах
                            </div>} */}
                            <div style={{ padding: "10px 0" }}>🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼</div>
                            {JSXMap(result?.protocoli, (e, idx) => {
                                return (<div key={idx} style={{ fontSize: "13px", textAlign: "left" }}>
                                    <div className="bg bg-grey" style={{ fontSize: "14px" }}>
                                        Протокол №{e?.protocol?.ID} <span><Badge content={Badge.dot} color={(e?.hasError) ? 'red' : '#87d068'} style={{
                                            minWidth: "8px",
                                            width: "8px",
                                            height: "8px"
                                        }}></Badge> <span style={{ fontSize: "12px" }}>{(e?.hasError) ? <span>Заполнен с ошибками</span> : <span>Заполнен правильно</span>}</span></span>
                                    </div>
                                    {/* Плюсы */}
                                    {(e?.countTatnsoriAllCriterionParamsPlus != 0 && ((e?.genderID == 1 && e?.protocol?.kolichestvoPlyusovPartneri == e?.countTatnsoriAllCriterionParamsPlus) || (e?.genderID == 2 && e?.protocol?.kolichestvoPlyusovPartnershi == e?.countTatnsoriAllCriterionParamsPlus))) && <div style={{ color: "#cf8600", padding: "5px" }}>
                                        Предупреждение! Не должно быть людей с полным комплектом плюсов по всем критериям в том же количестве, сколько плюсов надо ставить по каждому критерию (Количество плюсов партнеры)
                                    </div>}

                                    {/* Танцоры */}
                                    {JSXMap(e?.tantsori, (te, tidx) => (<div style={{ fontSize: "13px", textAlign: "left", padding: "0 0 3px 10px" }}>
                                        {(te.hasErrorPlace || te.hasErrorOtsenki || te.errorPlace || te.errorOtsenki || te.otsenki?.find(x => !!x.errorOtsenki) || te.placeObject.errorPlace) && <div><UserName item={te?.tantsor?.user} /></div>}
                                        {/* Места */}
                                        {te.hasErrorPlace && <div>
                                            <div>По результатам протокола танцор занял неправильное место</div>
                                            {te.errorPlace && <div style={{ fontStyle: "italic", color: "grey" }}>{te.errorPlace}</div>}
                                            {te.placeObject.errorPlace?.kommentarii && <div style={{ fontStyle: "italic", color: "grey", paddingLeft: "8px" }}>{te.placeObject.errorPlace.kommentarii}</div>}
                                        </div>}
                                        {/* Оценки */}
                                        {te.hasErrorOtsenki && <div>
                                            <div>В протоколе есть неправильные оценки</div>
                                            {te.errorOtsenki && <div style={{ fontStyle: "italic", color: "grey" }}>{te.errorOtsenki}</div>}
                                            <div>
                                                {JSXMap(te.otsenki, (oe, oidx) => (<div>
                                                    {oe?.errorOtsenka && <div>
                                                        <div><span>- установлена неправильная оценка</span> {realValue(e?.protocol?.protocolValueTypeID, oe?.otsenka?.value)} <span>по параметру {oe?.otsenka?.criterionParams?.name}</span></div>
                                                        {oe?.errorOtsenka?.kommentarii && <div style={{ fontStyle: "italic", color: "grey", paddingLeft: "8px" }}>{oe.errorOtsenka.kommentarii}</div>}
                                                    </div>}
                                                </div>))}
                                            </div>
                                        </div>}
                                    </div>))}
                                </div>)
                            })}
                        </div>
                        <div className='bg bg-grey' style={{ paddingTop: "5px" }}>
                            <div>Всего ошибок в протоколах: {result?.countErrorProtocoli}</div>
                            <div>Максимально допустимое число ошибок: {test?.dopustimoeKolvoOshibokProtokolov}</div>
                            {/* {result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov && <div>Вы прошли практический тест на судейство.</div>}
                            {result?.countErrorProtocoli > test?.dopustimoeKolvoOshibokProtokolov && <div>Вы не прошли практический тест на судейство.</div>} */}
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                            🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼🕺🏽💃🏼
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                            {(result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) && <div>Теоретический тест - <span style={{ color: "green" }}>пройден</span>.</div>}
                            {(result?.nabranniiProtsent < result?.test?.prokhodnoiProtsent) && <div>Теоретический тест - <span style={{ color: "red" }}>не пройден</span>.</div>}

                            {(result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov) && <div>Практический тест - <span style={{ color: "green" }}>пройден</span>.</div>}
                            {(result?.countErrorProtocoli > test?.dopustimoeKolvoOshibokProtokolov) && <div>Практический тест - <span style={{ color: "red" }}>не пройден</span>.</div>}
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                            {((result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) && (result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov)) && <div>
                                <div style={{ paddingBottom: "15px", fontSize: "16px", color: "green", fontWeight: "bold" }}>АТТЕСТАЦИЯ ПРОЙДЕНА - поздравляем!!!</div>
                                <div style={{ textAlign: "center" }}>
                                    <img src={badgeCheckIcon} style={{ width: "125px" }} />
                                </div>
                            </div>}
                            {!((result?.nabranniiProtsent >= result?.test?.prokhodnoiProtsent) && (result?.countErrorProtocoli <= test?.dopustimoeKolvoOshibokProtokolov)) && <div>
                                <div style={{ paddingBottom: "15px", fontSize: "16px", color: "red", fontWeight: "bold" }}>АТТЕСТАЦИЯ НЕ ПРОЙДЕНА</div>
                            </div>}
                        </div>
                    </div>}
                </div>
            </div>)
        }
        let body = test?.testVoprosiSudeiskikhAttestatsiiTest?.map((e, idx) => {
            let check = e?.testVariantiOtvetovVopros?.find(a => a?.selected)
            let res = result?.voprosi?.find(r => r?.vopros?.ID === e?.ID)
            let incorrect = false;
            if (res) {
                incorrect = !res.pravilnoOtvechen
            }

            return (
                {
                    key: `q${e?.ID}`,
                    // e?.kategoriyaVoprosaID
                    title: (
                        <div style={{ lineHeight: "16px" }}>
                            {mini && <div>{idx + 1}</div>}
                            {!mini && <div>Вопрос {idx + 1}</div>}
                            <div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: (mini) ? "center" : "space-between", gap: "3px" }}>
                                <div style={{ flex: "0 0" }}><Badge color={(!res) ? (check) ? 'orange' : '#d5d5d5' : (incorrect) ? 'red' : '#87d068'} style={{
                                    minWidth: "8px",
                                    width: "8px",
                                    height: "8px"
                                }}></Badge></div>
                                {!mini && <div style={{ flex: "1 1 auto", textAlign: "left" }}>{e?.tsennostVoprosa} {declOfNum(e?.tsennostVoprosa, ['балл', 'балла', 'баллов'])}</div>}
                            </div>
                        </div>
                    ),
                    children: (<div className='question' style={{ padding: "5px 10px", display: "flex", flexDirection: "column" }}>
                        <div style={{ fontSize: "12px", color: "grey" }}>Вопрос:</div>
                        <div style={{ fontSize: "14px" }}>
                            <Markdown className="md">{e?.tekstVoprosa}</Markdown>
                            {e?.multiSelect && <div style={{ fontSize: "12px", color: "grey" }}>Нужно выбрать все подходящие верные варианты</div>}
                        </div>
                        <div style={{ fontSize: "12px", color: "grey", marginTop: "15px" }}>Варианты ответов:</div>
                        <div className='answers' style={{ fontSize: "14px" }}>
                            {JSXMap(e?.testVariantiOtvetovVopros, (a, aidx) => (
                                <div key={a?.ID} className={`bg ${(a?.flag) ? "border-darkblue" : "border-grey"}`} style={{
                                    textAlign: "left",
                                    marginBottom: "5px"
                                }}>
                                    <Checkbox
                                        style={{ width: "100%" }}
                                        disabled={loading}
                                        checked={a?.selected}
                                        onChange={checked => {
                                            if (!test?.done) {
                                                setLoading(true)
                                                GET(auth, `/api/testisudeiskikhattestatsii/${(a?.selected) ? "uncheck" : "check"}-otvet/${a?.ID}`, ({ data }) => {
                                                    setTest(o => ({
                                                        ...o,
                                                        testVoprosiSudeiskikhAttestatsiiTest: updateInArray(o.testVoprosiSudeiskikhAttestatsiiTest, {
                                                            ...e,
                                                            testVariantiOtvetovVopros: updateArrayInArray(e.testVariantiOtvetovVopros, data)
                                                        })
                                                    }))
                                                    setLoading(false)
                                                }, (err) => errorCatch(err, () => setLoading(false)))
                                            } else {
                                                Modal.info({
                                                    title: 'Тест уже завершен',
                                                    content: 'Нельзя менять завершенный тест',
                                                    cancelText: "Отмена",
                                                    confirmText: "Хорошо",
                                                });
                                            }
                                        }}
                                    >
                                        <Markdown className="md">{a?.tekst}</Markdown>
                                    </Checkbox>
                                </div>
                            ))}
                        </div>
                        {(e?.kommentarii) && <div style={{ marginTop: "15px" }}>
                            <div style={{ fontSize: "12px", color: "grey" }}>Комментарий:</div>
                            <div>
                                {e?.kommentarii}
                            </div>
                        </div>}
                    </div>)
                }
            )
        })
        let testingPage = [];
        if (test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya?.length) {
            let check = _.every(test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya, { 'completed': true });
            let res = result;
            let incorrect = result && (result?.countErrorProtocoli > result?.test?.dopustimoeKolvoOshibokProtokolov); //test?.nepravilnieProtokli > 0;
            testingPage.push({
                key: 'test',
                title: (
                    <div style={{ lineHeight: "16px" }}>
                        {mini && <div><i className="fa fa-file-text-o"></i></div>}
                        {!mini && <div>Протокол</div>}
                        <div style={{ fontSize: "11px", color: "grey", display: "flex", justifyContent: (mini) ? "center" : "space-between", gap: "3px" }}>
                            <div style={{ flex: "0 0" }}><Badge color={(!res) ? (check) ? 'orange' : '#d5d5d5' : (incorrect) ? 'red' : '#87d068'} style={{
                                minWidth: "8px",
                                width: "8px",
                                height: "8px"
                            }}></Badge></div>
                        </div>
                    </div>
                ),
                children: (<div className='question' style={{ padding: "5px 10px", display: "flex", flexDirection: "row", gap: "15px", height: "100%" }}>
                    <div style={{ flex: "1 1 auto", overflowY: "auto" }}>
                        <div style={{ fontSize: "12px", color: "grey" }}>Описание:</div>
                        {JSXMap(test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya, ((e, idx) => (<div key={idx}>
                            <Markdown className="md">
                                {e?.annotatsiya}
                            </Markdown>
                        </div>)))}
                        <div style={{ fontSize: "12px", color: "grey", marginTop: "15px" }}>Доступные протоколы:</div>
                        {JSXMap(test?.cloneParametriProtokolovTestaSudeiskayaAttestatsiya, (e, idx) => (<div key={idx} style={{ fontSize: "14px" }}>
                            Протокол №{e?.ID} <span><Badge content={Badge.dot} color={(!e?.completed) ? 'red' : '#87d068'} style={{
                                minWidth: "8px",
                                width: "8px",
                                height: "8px"
                            }}></Badge> <span style={{ fontSize: "12px" }}>{(e?.completed) ? "Заполнен" : "Не заполнен"}</span></span>
                        </div>))}

                        {/* <div style={{ marginTop: "15px", textAlign: "left" }}>
                            <Button color='primary' fill='outline' onClick={() => {
                                navigate(`/app/testing/${testing?.ID}/protocols`);
                            }}>
                                Перейти к протоколам
                            </Button>
                        </div> */}
                    </div>
                    <div style={{ height: "100%", padding: "4px", backgroundColor: "white", flex: "0 0 380px", overflowY: "auto", border: "1px solid #e9e9e9", borderRadius: "6px" }}>
                        <Judge testing={testing} backArrow={false} />
                    </div>
                </div>)
            })
        }
        return [begin, ...body, ...testingPage, end]
    }, [test, mini, result])

    return (
        <TestingContext.Provider value={testing}>
            <PageLayout
                hideSider={true}
                /*hideBreadcrumbs={true}*/
                bottom={() => (
                    <div className='bg bg-grey' style={{ textAlign: "left", padding: "3px", display: "flex", justifyContent: "space-between", gap: "5px", backgroundColor: "white" }}>
                        <div style={{ flex: "0 0" }}>
                            <Button type="text" onClick={() => setMini(o => !o)}>
                                <i className="fa fa-th-list" style={{ color: (!mini) ? 'rgb(128, 128, 128)' : 'rgb(22, 119, 255)' }}></i>
                            </Button>
                        </div>
                        <div style={{ flex: "1 1 auto" }}>
                        </div>
                        <div style={{ flex: "0 0", display: "flex", gap: "10px" }}>
                            <Button onClick={prev} type="text"><i className='fa fa-chevron-left'></i></Button>
                            <Button onClick={next} type="text"><i className='fa fa-chevron-right'></i></Button>
                        </div>
                    </div>
                )}
            >
                <div className='testing' style={{ backgroundColor: "white", borderRadius: "4px" }}>
                    <div className="questions" style={{ padding: "10px" }}>
                        <Tabs
                            activeKey={activeKey}
                            onChange={setActiveKey}
                            tabPosition={"left"}
                            items={tabs.map((item, i) => {
                                return {
                                    label: item.title,
                                    key: item.key,
                                    children: item.children,
                                };
                            })}
                        />
                    </div>
                </div>
            </PageLayout>

            {/* <MenuLevelTwoContext.Provider value={menu(status, notify)}>
                {(!siteAccess || siteAccess == "allow") && <Routes>
                    {defaultRoute(menu(status, notify), role_by_id)}
                    {menu(status, notify).map((e, idx) => {
                        if (e.component && access(e, role_by_id)) {
                            return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                                <BreadcrumbsProvider value={{
                                    // parent: props?.level,
                                    uuid: e?.uuid,
                                    name: e?.name,
                                    color: e?.color,
                                    role: e?.role,
                                    hidden: e.hidden
                                }}>
                                    {e.component({})}
                                </BreadcrumbsProvider>}
                            />
                        }
                    })}
                </Routes>}
            </MenuLevelTwoContext.Provider> */}
        </TestingContext.Provider>
    );
}